export default {"src":"/_next/static/media/moments-logo-2.b68cfb75.svg","height":130,"width":100,"blurWidth":0,"blurHeight":0};